import { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
import GPAPlanner from "./SharedGPAPlanner";
const TITLE = "حساب المعدل التراكمي من 5 - حاسبة المعدل الجامعي";
const DESCRIPTION =
  "احسب المعدل التراكمي للمقررات الجامعية بسهولة من خلال حاسبة المعدل الجامعي. اعرف كيفية حساب المعدل التراكمي من 5 بسرعة ودقة.";
const KEYWORDS =
  "حساب المعدل التراكمي, حاسبة المعدل الجامعي, حساب المعدل من 5, حساب المعدل الجامعي";
const OG_URL = "https://do-calculate.com/calculator/ar/gpa5";
function GPA5() {
  const [courses, setCourses] = useState([
    { name: "رياضيات", credits: "3", grade: "A" },
    { name: "فيزياء", credits: "2", grade: "B+" },
    { name: "حاسوب", credits: "3", grade: "A-" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [gpa, setGPA] = useState(0);
  const gradeOptions = [
    "A+",
    "A",
    "A-",
    "B+",
    "B",
    "C+",
    "C",
    "D+",
    "D",
    "D-",
    "F",
  ];
  const addCourse = () => {
    setCourses([...courses, { name: "", credits: "", grade: "A+" }]);
  };
  const removeCourse = (index) => {
    const updatedCourses = [...courses];
    updatedCourses.splice(index, 1);
    setCourses(updatedCourses);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedCourses = [...courses];
    updatedCourses[index][name] = value;
    setCourses(updatedCourses);
  };
  const calculate = () => {
    setIsLoading(true);
    setError(null);
    let totalGradePoints = 0;
    let creditsSum = 0;
    for (const course of courses) {
      const credits = parseFloat(course.credits);
      const grade = course.grade;
      if (!isNaN(credits)) {
        const gradePoints = calculateGradePoints(grade);
        if (!isNaN(gradePoints)) {
          totalGradePoints += credits * gradePoints;
          creditsSum += credits;
        }
      }
    }
    if (creditsSum === 0) {
      setError("ادخل قيم صحيحة");
    } else {
      const calculatedGPA = (totalGradePoints / creditsSum) * 5;
      setGPA(calculatedGPA.toFixed(2));
    }
    setIsLoading(false);
  };
  const calculateGradePoints = (grade) => {
    const gradeMap = {
      "A+": 5.0,
      A: 4.0,
      "A-": 3.7,
      "B+": 3.3,
      B: 3.0,
      "B-": 2.7,
      "C+": 2.3,
      C: 2.0,
      "C-": 1.7,
      "D+": 1.3,
      D: 1.0,
      "D-": 0.7,
      F: 0.0,
    };
    if (grade === "F") {
      return 0;
    } else {
      return gradeMap[grade] || NaN;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    احسب المعدل التراكمي من 5
                  </h2>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="course">المادة (اختياري)</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="credits">الساعات</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="grade">العلامة</label>
                    </b>
                  </div>
                </div>
                {courses.map((course, index) => (
                  <div key={index}>
                    <div className="form-group d-flex align-items-center">
                      <input
                        type="text"
                        name="name"
                        id="course"
                        placeholder="المادة"
                        value={course.name}
                        style={{ width: "100%", marginLeft: "4px" }}
                        className="form-control ml-2"
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="credits"
                        id="credits"
                        placeholder="3"
                        value={course.credits}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <select
                        name="grade"
                        id="grade"
                        value={course.grade}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      >
                        {gradeOptions.map((option, gradeIndex) => (
                          <option key={gradeIndex} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <button
                        className="text-white btn bg-secondary"
                        onClick={() => removeCourse(index)}
                      >
                        حذف
                      </button>
                    </div>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addCourse}
                >
                  إضافة مادة
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculate}
                       >
                    احسب
                    </button>              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <br />
              {error && (
                <div className="alert alert-warning">
                  <b>
                    <u> حدث خطأ :</u>
                  </b>{" "}
                  يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                </div>
              )}
              {gpa > 0 && (
                <div
                  style={{ fontSize: "19px" }}
                  className="bg-light bg-gradient text-dark"
                >
                  <div className="p-3 bg-success bg-gradient text-white">
                    <strong>النتائج</strong>
                  </div>
                  <div>
                    <table >
                      <thead>
                        <tr>
                          <th>المادة</th>
                          <th>الدرجة</th>
                          <th>الساعات المعتمدة</th>
                          <th>نقاط الدرجات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {courses.map((course, index) => (
                          <tr key={index}>
                            <td>{course.name}</td>
                            <td>{course.grade}</td>
                            <td>{course.credits}</td>
                            <td>{course.points}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <GPAPlanner />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية حساب التراكمي من 5{" "}
                    </h2>{" "}
                  </u>
                  <p>
                    لحساب معدل الأداء الأكاديمي الخاص بك، قم بقسمة إجمالي عدد
                    نقاط الدرجات التي حصلت عليها على إجمالي عدد وحدات الدراسات
                    ذات الدرجات الحروفية التي قمت بها. لكل وحدة دراسية، يتم كسب
                    الدرجات التالية:
                  </p>
                  <ul>
                    <li>A+ (5.0)</li>
                    <li>A (4.0)</li>
                    <li>A- (3.7)</li>
                    <li>B+ (3.3)</li>
                    <li>B (3.0)</li>
                    <li>B- (2.7)</li>
                    <li>C+ (2.3)</li>
                    <li>C (2.0)</li>
                    <li>C- (1.7)</li>
                    <li>D+ (1.3)</li>
                    <li>D (1.0)</li>
                    <li>D- (0.7)</li>
                    <li>F (0.0)</li>
                  </ul>
                  <p>
                    لحساب إجمالي نقاط الدرجات على سجلك الأكاديمي، قم بضرب نقاط
                    الدرجات لكل درجة حصلت عليها بعدد الوحدات في الدورة (استشر
                    دليل الكلية الخاص بك بشأن الدورات المكررة ودرجات الانقطاع).
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GPA5;
